<template>
  <section>
    <div v-if="loading" class="text-center py-5">
      <div
        class="spinner-border"
        style="width: 3rem; height: 3rem;"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div v-if="Object.keys(detail).length > 1">
        <div class="container p-4">
          <div class="row p-3 mb-5">
            <div
              class="col-lg-3 text-center d-flex align-items-start justify-content-center"
            >
              <img
                v-if="!checkLinkPDF"
                :src="imageURL"
                class="w-100 rounded"
                alt="image"
              />
              <iframe
                v-else
                style="width:100%;height:300px;border:0px;"
                :src="`https://static.sc.cloudapp.web.id/uploader/files/${detail.cover}`"
                allow="autoplay"
              ></iframe>
            </div>
            <div class="col-lg-9 pt-5 pt-md-0">
              <h4 class="my-3">{{ detail.judul }}</h4>
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                data-toggle="modal"
                data-target="#readModal"
              >
                Baca Online
              </button>
              <div class="row align-items-center my-3">
                <div class="col-6 col-lg-2">
                  <span>DETAIL BUKU</span>
                </div>
                <div class="col-5 col-lg-10 p-0">
                  <hr />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 mb-3">
                  <div>Jenis Pustaka</div>
                  <small class="text-muted">{{ jenisPustaka }}</small>
                </div>
                <div class="col-lg-4 mb-3">
                  <div>Tahun Terbit</div>
                  <small class="text-muted">{{ detail.tahun_terbit }}</small>
                </div>
                <div class="col-lg-4 mb-3">
                  <div>Kelompok Pembaca</div>
                  <small class="text-muted">
                    {{ kelompokPembaca }}
                  </small>
                </div>
                <div class="col-lg-4 mb-3">
                  <div>Kepengarangan</div>
                  <small class="text-muted">{{ kepengaranganDisplay }}</small>
                </div>
                <div class="col-lg-4 mb-3">
                  <div>Sinopsis</div>
                  <small class="text-muted" v-if="!showMore">
                    {{ detail.sinopsis.slice(0, 200) }}...
                    <span
                      v-show="detail.sinopsis.length >= 200"
                      @click="showMore = true"
                      class="text-primary"
                      style="cursor: pointer"
                      >Lihat lebih</span
                    >
                  </small>
                  <small v-else>
                    {{ detail.sinopsis }}
                    <span
                      @click="showMore = false"
                      class="text-primary"
                      style="cursor: pointer"
                    >
                      Lihat sedikit
                    </span>
                  </small>
                </div>
                <div class="col-lg-4 mb-3">
                  <div>Distributor</div>
                  <small class="text-muted">{{ detail.distributor }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div
          class="modal fade w-100"
          id="readModal"
          tabindex="-1"
          aria-labelledby="readModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="readModalLabel">
                  {{ detail.judul }}
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <object
                  type="application/pdf"
                  :data="dummy"
                  width="100%"
                  height="800"
                  aria-label="readModal"
                >
                  <p>Silahkan klik tombol unduh untuk membaca</p>
                  <a className="btn btn-light" :href="dummy">
                    <i className="fas fa-fw fa-download" />
                    Unduh
                  </a>
                </object>
              </div>
            </div>
          </div>
        </div>
        <!-- End Modal -->
      </div>
      <div v-else>
        <div class="text-center my-5">
          <img
            width="60"
            src="@/assets/not-found.png"
            class="img-fluid"
            alt=""
          />
          <h4 class="text-center mt-2">Buku tidak ditemukan.</h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  name: "Book Detail",
  data() {
    return {
      loading: false,
      showMore: false,
      detail: {},
    };
  },
  computed: {
    lampiran() {
      return `https://static.sc.cloudapp.web.id/uploader/files/${this.detail.lampiran}`;
    },
    dummy() {
      return `https://static.sc.cloudapp.web.id/uploader/files/${this.detail.dummy}`;
    },
    prelim() {
      return `https://static.sc.cloudapp.web.id/uploader/files/${this.detail.prelim}`;
    },
    checkLinkPDF() {
      return this.detail.cover_type == "pdf" ? true : false;
    },
    imageURL() {
      return (
        `https://static.sc.cloudapp.web.id/uploader/files/${this.detail.cover}` ??
        "https://image.web.id/images/Dummy.png"
      );
    },
    jenisPustaka() {
      switch (this.detail.jenis_pustaka) {
        case "1":
          return "Fiksi";
        case "2":
          return "Non Fiksi";
        default:
          return "Buku";
      }
    },
    kelompokPembaca() {
      switch (this.detail.kelompok_pembaca) {
        case "1":
          return "Anak";
        case "2":
          return "Dewasa";
        case "3":
          return "Semua Umur";
        default:
          return "Semua Umur";
      }
    },

    // Tambahan untuk handle JSON atau string biasa
    kepengaranganDisplay() {
      if (!this.detail.kepengarangan) return "-";

      try {
        // Coba parse JSON
        const parsed = JSON.parse(this.detail.kepengarangan);
        if (Array.isArray(parsed)) {
          return parsed
            .map((item) => {
              const key = Object.keys(item)[0];
              const value = item[key];
              return `${key.replace(/_/g, " ")}: ${value}`;
            })
            .join(", ");
        }
        // Jika hasil parse bukan array, tampilkan langsung
        return this.detail.kepengarangan;
      } catch (e) {
        // Jika gagal parse (bukan JSON), tampilkan string apa adanya
        return this.detail.kepengarangan;
      }
    },
  },
  methods: {
    getDetailBook() {
      this.loading = true;
      const id = this.$route.params.id;
      axios
        .get(`https://api.buku.kemendikdasmen.go.id/api/isbn/publicDetail/${id}`, {
          headers: {
            Authorization:
              "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiNTU5NiIsInVzZXJuYW1lIjoiY3ZwcmF0YW1hbWFpbGluYXRvcmNvbSIsImVtYWlsIjoiY3ZwcmF0YW1hQG1haWxpbmF0b3IuY29tIiwiZnVsbG5hbWUiOiJDViBQcmF0YW1hIFNhcmkiLCJyb2xlX25hbWUiOiJQZW5lcmJpdCIsInJvbGVfaWQiOiIxNSIsImF2YXRhciI6Imh0dHBzOlwvXC93d3cuZ3JhdmF0YXIuY29tXC9hdmF0YXJcL2E0MTlhMzQwOGZiMzBmYmY3NzcyNjI0Mjc0MmNlYjA5P3NpemU9MTAwJmQ9aHR0cHMlM0ElMkYlMkZzdGF0aWMuY2RuLWNkcGwuY29tJTJGc291cmNlJTJGMiUyRmNvZGVwb2xpdGFuLWRlZmF1bHQtYXZhdGFyLnBuZyJ9.YS06vKtZrl1P2bRRxlx3PZ_xVZAiIjCEIK8KgDTBAR0",
          },
        })
        .then((res) => {
          this.detail = res.data;
          if (res.data.cover && res.data.cover.toLowerCase().endsWith(".pdf")) {
            this.detail.cover_type = "pdf";
          }
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
  },
  created() {
    this.getDetailBook();
  },
};
</script>
